import SpacedTexts from 'Global/Components/CommonComponents/SpacedTexts/SpacedTexts';
import React from 'react';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import { dictionary } from './dictionary/dictionary';
import { Price3DigitSplitter } from 'utils/Price3DigitSplitter';

const Receiption_Information = ({ receiption }) => {
  const { desc, traceId, price } = dictionary();
  return (
    <React.Fragment>
      <SpacedTexts
        firstText={`${desc}:`}
        secondText={ArabicToPersian(
          receiption?.Description
        )}
        enableAlignItems={'center'}
        fullWidth={true}
      />
      <SpacedTexts
        firstText={`${traceId}:`}
        secondText={`${receiption?.ShomarePaigiri}`}
        enableAlignItems={'center'}
        fullWidth={true}
        textAlign="right"
      />
      <SpacedTexts
        firstText={`${price}:`}
        secondText={Price3DigitSplitter(
          receiption?.mablagh
        )}
        enableAlignItems={'center'}
        fullWidth={true}
        textAlign="right"
      />
    </React.Fragment>
  );
};

export default Receiption_Information;
